// extracted by mini-css-extract-plugin
export default {"summary_section":"Summary_summary_section__xyywB","expanded_section":"Summary_expanded_section__q1u5Z","tile_container":"Summary_tile_container__jO0qy"};